import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const LegendServiceRow = ({ iconComponent, onClick, isActive, title }) => (
   <div
      className={classNames("legend-service-row", { 'legend-service-row--inactive': !isActive, 'legend-service-row--no-click': !onClick })}
      onClick={onClick}
   >
      <div className="legend-service-row__icon-container">{iconComponent}</div>
      <span className="legend-service-row__title">{title}</span>
   </div>
);

LegendServiceRow.defaultProps = {
   isActive: true,
};

LegendServiceRow.propTypes = {
   iconComponent: PropTypes.any.isRequired,
   onClick: PropTypes.func,
   isActive: PropTypes.bool,
   title: PropTypes.string.isRequired
};

export default LegendServiceRow;
